var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.496 0.666 60.075 60.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4a4a4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 6 L56 10 L19 59 L10 55 Q8 52 11 49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13 L19 9 L52 49 Q54 53 50 55 L45 55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscard);
export default __webpack_public_path__ + "static/media/discard.3f03ba19368a413ebeb7fcdefdce3fe3.svg";
export { ForwardRef as ReactComponent };